import Bror from './bror';
import Jonaxel from './jonaxel';
import Boaxel from './boaxel';
import Aurdal from './aurdal';
import Ivar from './ivar';
import Elvarli from './elvarli';
import { RANGES } from '../../constants';
import { applicationSettings } from '../../settings/application';
import { thunkConditionalDisplayIntroPopups } from '../../state/popups/popupsThunks';
import { Thunk } from '../../generalTypes';

const ranges = {
  [RANGES.BROR]: Bror,
  [RANGES.JONAXEL]: Jonaxel,
  [RANGES.AURDAL]: Aurdal,
  [RANGES.IVAR]: Ivar,
  [RANGES.BOAXEL]: Boaxel,
  [RANGES.ELVARLI]: Elvarli,
};

export const sceneReady: Thunk = () => dispatch => {
  dispatch(thunkConditionalDisplayIntroPopups());
};

export default {
  sceneReady,
  ...ranges[applicationSettings.applicationName],
};
